import type { Texts } from '../useTexts'

export const createValidateTemplateCustom = (
  texts: Texts,
  templateCustom: string,
  notificationWay: uui.domain.client.rm.NotificationWay,
  includeMessageTrackingLink: boolean,
  includeMessageUnsubscriptionInstructions: boolean,
  templateDefaultLimits: uui.domain.client.rm.NotificationTemplateLimits,
  templateCustomLimits: uui.domain.client.rm.NotificationTemplateLimits,
) => {
  const hotwordsRegexp = new RegExp(/@@(.*?)@@/gm)

  const templateCustomRequired = {
    id: 'templateCustomRequired',
    field: 'templateCustom',
    message: texts.requiredField,
    priority: 10,
  }

  let messageLength = 0

  // Calculate max message length based on the notification type
  const maxLength = notificationWay === 'PHONE' ? 500 : 2500

  // Retrieve current character limits
  const limits = { ...templateDefaultLimits, ...templateCustomLimits }

  // Retrieve tokens in text
  const hotwords = templateCustom.match(hotwordsRegexp)?.map(hotword => hotword.replace(/@@/g, ''))

  // Adds length of the message without hotwords/links/instructions
  messageLength += templateCustom.replace(hotwordsRegexp, '').length

  // If hotwords are present add the correct length from each one
  for (const hotword of hotwords || []) {
    if (!limits[hotword]) continue

    messageLength += limits[hotword]
  }

  // If we need to include the tracking link, add the Tracking Link length
  if (includeMessageTrackingLink) {
    messageLength += limits.TrackingLink ?? 0
  }

  // If we need to include the tracking link, add the Unsubscribe length
  if (includeMessageUnsubscriptionInstructions) {
    messageLength += limits.Unsubscribe ?? 0
  }

  const templateCustomMaxLengthError = {
    id: 'templateCustomMaxLengthError',
    field: 'templateCustom',
    message: texts.messageTooLong(maxLength),
    priority: 9,
  }

  const requiredError = templateCustom.trim().length === 0
  const maxLengthError = messageLength > maxLength

  return {
    [templateCustomRequired.id]: requiredError ? templateCustomRequired : undefined,
    [templateCustomMaxLengthError.id]: maxLengthError ? templateCustomMaxLengthError : undefined,
  }
}
